<div *ngIf="expand" [@expand]>
    <ng-content></ng-content>
</div>
